import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AddEditPatInsPopup from './AddEditPatInsPopup';
import { post } from '../Auths/AuthToken';

import setUiMessage from '../../Utilities/Tostify';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import CheckEligibilityPopup from '../Schedular/Appointment/CheckEligibilityPopup';
import { useDispatch, useSelector } from 'react-redux';
import { handleGlobalReload } from '../../redux/slices/appSlice';
import Button from '../Button';

function PatientInsurance({ patientId }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);

  const [allData, setAllData] = useState(null);
  const [selectedIns, setSelectedIns] = useState(null);
  const [selInsId, setSelInsId] = useState(null);
  const [changeInsId, setChangeInsId] = useState(null);
  const [checkEligibilityPopup, setCheckEligibilityPopup] = useState(false);

  const [checkInsStatus, setCheckInsStatus] = useState(false);
  const [sucPrams, setSucPrams] = useState('');

  const [selInsTypeText, setSelInsTypeText] = useState(false);
  const [nextInsTypeText, setNextInsTypeText] = useState(false);

  const [insAddEditPopup, setInsAddEditPopup] = useState(false);
  useEffect(() => {
    (async (prams) => {
      try {
        const response = await post(
          'api/patient/ManageInsurance/patInsuranceDetail',
          { patientId: patientId }
        );
        if (response.status === 200) {
          setAllData(response?.data);
          if (response?.data && response?.data?.insActiveList.length > 0) {
            const patSeltedInsId = response?.data?.insActiveList.filter(
              (data) => data?.insType === 'Primary'
            );
            if (patSeltedInsId[0]?.insId) {
              setSelInsId(patSeltedInsId[0]?.insId);
              setChangeInsId(patSeltedInsId[0]?.insId);
              setSelectedIns(response?.data?.insList[patSeltedInsId[0]?.insId]);
            }
          } else if (
            response?.data &&
            response?.data?.insInactiveList.length > 0
          ) {
            setSelInsId(response?.data?.insInactiveList[0]?.insId);
            setChangeInsId(response?.data?.insInactiveList[0]?.insId);
            setSelectedIns(
              response?.data?.insList[response?.data?.insInactiveList[0]?.insId]
            );
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, globalReload]);

  const handleAddEditInsInfo = () => {
    setChangeInsId(null);
    setInsAddEditPopup(true);
  };

  const handleSelectInsurance = (insId) => {
    setSelInsId(insId);
    setChangeInsId(insId);
    setSelectedIns(allData.insList[insId]);
  };

  const handleOpenImage = (url, target = '_blank') => {
    window.open(url, target);
  };

  const handleImagePrint = (url) => {
    if (url) {
      var printWindow = window.open('', '', '');
      printWindow.document.open();
      printWindow.document.write(`
      <html>
        <head>
          <title>Printable Image</title>
        </head>
        <body>
          <img src=${url} />
          <script>
            setTimeout(() => {
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            }, 0);
          </script>
        </body>
      </html>
    `);
      printWindow.document.close();
    }
  };

  const handleChangeIns = () => {
    setChangeInsId(selInsId);
    setInsAddEditPopup(true);
  };

  const handleCheckEligibilityClick = () => {
    setCheckEligibilityPopup(true);
  };
  const handleChangeInsStatus = async (
    insId,
    insProType,
    insProTypeTex,
    type
  ) => {
    try {
      if (type === '2') {
        handleChangeInsStatusConfirm([insId, type]);
      } else {
        const response = await post(
          'api/patient/ManageInsurance/chckInsurancePriority',
          {
            type: insProType,
            patientId: patientId,
          }
        );
        if (response.status === 200) {
          if (response.data?.status) {
            setCheckInsStatus(true);
            setSucPrams([insId, type, response.data?.maxPriority]);
            setSelInsTypeText(insProTypeTex);
            setNextInsTypeText(response.data?.maxPriorityName);
          } else {
            handleChangeInsStatusConfirm([insId, type]);
          }
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleChangeInsStatusConfirm = async (prams) => {
    let [insId, type, periorty] = prams;

    try {
      const response = await post(
        'api/patient/ManageInsurance/changeInsuranceStatus',
        {
          insuranceId: insId,
          status: type, //2->mark as inactive forecly, 0->active
          priority: periorty ? periorty : '',
          loginUserId: user?.id,
        }
      );
      if (response.status === 200) {
        if (response?.data) {
          setCheckInsStatus(false);
          dispatch(handleGlobalReload(!globalReload));
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  return (
    <div className="insu-main-con">
      <div className="qc-mid-bdy-hdr clear-top10 flex items-center justify-between">
        <span className="widget-hdr-title bold clear-top">Insurance Info:</span>
        <Button
          variant="primary"
          onClick={handleAddEditInsInfo}
          // style={{ fontSize: '13px', padding: '3px 12px' }}
        >
          Add New
        </Button>
      </div>
      {allData?.insActiveList?.length > 0 ||
      allData?.insInactiveList?.length > 0 ? (
        <div className="insu-actinact-sec flex-sec width100">
          <div className="insu-inact-sec">
            <div className="insu-inact-sec-hdr">Active Payors</div>
            <div className="insu-inact-sec-bdy">
              {allData &&
                allData?.insActiveList?.map((actIns, i) => (
                  <div
                    key={i}
                    className={
                      selInsId === actIns?.insId
                        ? 'insu-inact-sec-bdy-rw actv-insu'
                        : 'insu-inact-sec-bdy-rw'
                    }
                    onClick={() => handleSelectInsurance(actIns?.insId)}
                  >
                    <span className="insu-prirty">{actIns?.insType}</span>
                    <span className="Payor-nm">
                      {actIns?.insName}
                      {actIns?.insType === 'Primary' && (
                        <span className="eligblity-conf">&#10003;</span>
                      )}
                    </span>
                    <span className="Payor-id">
                      Insured ID: {actIns?.insuredId}
                    </span>
                    <span className="Payor-dt">
                      Insured Relationship: {actIns?.insuredRelationShip}
                    </span>
                    <span className="Payor-dt">
                      From: {actIns?.startDt}
                      {/* to 04-20-2024 */}
                    </span>
                    <span className="Payor-dt">
                      {/* Eligibility checked: 04-20-2023 */}
                    </span>
                  </div>
                ))}
            </div>

            <div className="insu-inact-sec-hdr">Inactive Payors</div>
            {allData &&
              allData?.insInactiveList?.map((inActIns, j) => (
                <div
                  key={j}
                  className={
                    selInsId === inActIns?.insId
                      ? 'insu-inact-sec-bdy-rw actv-insu'
                      : 'insu-inact-sec-bdy-rw'
                  }
                  onClick={() => handleSelectInsurance(inActIns?.insId)}
                >
                  <span className="insu-prirty inactv-insu-prty">
                    {inActIns?.insType}
                  </span>
                  <span className="Payor-nm sec-colr">{inActIns?.insName}</span>
                  <span className="Payor-id">
                    Insured ID: {inActIns?.insuredId}
                  </span>
                  <span className="Payor-dt">
                    Insured Relationship: {inActIns?.insuredRelationShip}
                  </span>
                  <span className="Payor-dt">
                    From: {inActIns?.startDt}
                    {inActIns?.endDt ? `to ${inActIns?.endDt}` : ''}
                  </span>
                  <span className="Payor-dt">
                    {/* Eligibility checked: 04-05-2021 */}
                  </span>
                </div>
              ))}
          </div>
          <div className="insu-act-sec">
            <div className="insu-act-sec-bdy-rw flex-sec">
              <div className="width100">
                <span className="insu-prty clear-right10">
                  {selectedIns?.insType}:
                </span>
                <span onClick={handleChangeIns}>
                  <Link className="insu-actn-lnk bold">Change</Link>
                </span>
                <span className="red clear-left10 clear-right10"> | </span>
                {selectedIns?.isAct ? (
                  <span
                    onClick={() =>
                      handleChangeInsStatus(
                        selectedIns?.insId,
                        selectedIns?.insProType, //0,1,2...etc
                        selectedIns?.insType, //priamary,secondery...
                        '2'
                      )
                    }
                  >
                    <Link className="insu-actn-lnk bold">Mark Inactive</Link>
                  </span>
                ) : (
                  <span
                    onClick={() =>
                      handleChangeInsStatus(
                        selectedIns?.insId,
                        selectedIns?.insProType, //0,1,2...etc
                        selectedIns?.insType, //priamary,secondery...
                        '0'
                      )
                    }
                  >
                    <Link className="insu-actn-lnk bold">Mark Active</Link>
                  </span>
                )}
              </div>
              <div
                className="width100 flex-sec"
                style={{ flexDirection: 'row-reverse' }}
              >
                <Link className="insu-actn-lnk bold hide">View Report</Link>
                <span className="red clear-left10 clear-right10 hide"> | </span>
                <Link
                  className="insu-actn-lnk bold"
                  onClick={handleCheckEligibilityClick}
                >
                  Check Eligibility
                </Link>
                {checkEligibilityPopup && (
                  <CheckEligibilityPopup
                    patientId={patientId}
                    insId={selInsId}
                    flag={1}
                    setCheckEligibilityPopup={setCheckEligibilityPopup}
                  />
                )}
              </div>
            </div>
            <div className="insu-act-sec-hdr">Insurance Card:</div>
            <div className="insu-act-sec-bdy flex-sec">
              <div className="insu-act-sec-bdy-lft grid-sec">
                <div className="insu-act-sec-bdy-rw flex-sec">
                  <span className="nsu-act-lbl bold">Front View:</span>
                  <span className="nsu-act-val flex-sec"></span>
                </div>

                <div className="insu-act-sec-bdy-rw grid-sec">
                  {selectedIns?.scan_insurance_card ? (
                    <Link>
                      <img
                        className="insu-card"
                        src={selectedIns?.scan_insurance_card}
                        alt={''}
                        onClick={() =>
                          handleOpenImage(selectedIns?.scan_insurance_card)
                        }
                      />
                    </Link>
                  ) : (
                    <img
                      className="insu-card"
                      src={'./images/dummy-ins-crd.png'}
                      alt={''}
                    />
                  )}

                  <Link
                    className="prnt-card"
                    onClick={() =>
                      handleImagePrint(selectedIns?.scan_insurance_card)
                    }
                  >
                    Print Card
                  </Link>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rt grid-sec">
                <div className="insu-act-sec-bdy-rw flex-sec">
                  <span className="nsu-act-lbl bold">Back View:</span>
                  <span className="nsu-act-val flex-sec"></span>
                </div>
                <div className="insu-act-sec-bdy-rw grid-sec">
                  {selectedIns?.scan_insurance_card_backside ? (
                    <img
                      className="insu-card"
                      src={selectedIns?.scan_insurance_card_backside}
                      alt={''}
                      onClick={() =>
                        handleOpenImage(
                          selectedIns?.scan_insurance_card_backside
                        )
                      }
                    />
                  ) : (
                    <img
                      className="insu-card"
                      src={'./images/dummy-ins-crd.png'}
                      alt={''}
                    />
                  )}
                  <Link
                    className="prnt-card"
                    onClick={() =>
                      handleImagePrint(
                        selectedIns?.scan_insurance_card_backside
                      )
                    }
                  >
                    Print Card
                  </Link>
                </div>
              </div>
            </div>
            <div className="insu-act-sec-hdr">Payor Info:</div>
            <div className="insu-act-sec-bdy">
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Payor:</span>
                  <span className="nsu-act-val maroon">
                    {selectedIns?.insName}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">PCP CoPay:</span>
                  <span className="nsu-act-val">{selectedIns?.co_pay}</span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec alt-rw">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Plan Name:</span>
                  <span className="nsu-act-val">{selectedIns?.plan_name}</span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Specialist CoPay:</span>
                  <span className="nsu-act-val">{selectedIns?.sp_co_pay}</span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Type:</span>
                  <span className="nsu-act-val">{selectedIns?.type}</span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Deductible:</span>
                  <span className="nsu-act-val">{selectedIns?.deductible}</span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Relationship:</span>
                  <span className="nsu-act-val maroon">
                    {selectedIns?.insuredRelationShip}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Insurance Reason Code:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.insurance_reason_code}
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Insured’s ID:</span>
                  <span className="nsu-act-val maroon">
                    {selectedIns?.insuredId}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Other claim ID:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.other_claim_id}
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Group/FECA #:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.group_number}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Insured's Sig:</span>
                  <span className="nsu-act-val">
                    {(() => {
                      if (selectedIns?.insured_signature === '1') {
                        return 'SOF';
                      } else if (selectedIns?.insured_signature === '2') {
                        return 'Name';
                      } else if (selectedIns?.insured_signature === '3') {
                        return 'Blank';
                      }
                    })()}
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Start Date:</span>
                  <span className="nsu-act-val">{selectedIns?.startDt}</span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Patient's Sig:</span>
                  <span className="nsu-act-val">
                    {(() => {
                      if (selectedIns?.patient_signature === '1') {
                        return 'SOF';
                      } else if (selectedIns?.patient_signature === '2') {
                        return 'Name';
                      } else if (selectedIns?.patient_signature === '3') {
                        return 'Blank';
                      }
                    })()}
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">End Date:</span>
                  <span className="nsu-act-val">{selectedIns?.endDt}</span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Patient's Signature date:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.patient_signature_date}
                  </span>
                </div>
              </div>
            </div>

            <div className="insu-act-sec-hdr">
              Insured Info [{selectedIns?.insuredRelationShip}]:
            </div>
            <div className="insu-act-sec-bdy">
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">First Name:</span>
                  <span className="nsu-act-val maroon">
                    {selectedIns?.subscriber_first_name}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Zip:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_zip}
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec alt-rw">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Middle Name:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_middle_name}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Home Phone:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_home_phone}
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Last Name:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_last_name}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Work Phone:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_home_phone}
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Address1:</span>
                  <span className="nsu-act-val maroon">
                    {selectedIns?.subscriber_address1}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Sex:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_gender}
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Address2:</span>
                  <span className="nsu-act-val maroon">
                    {selectedIns?.subscriber_address2}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">DOB:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_dob}
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">City:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_city}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">SSN:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_ssn}
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">State:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_state}
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Email Id:</span>
                  <span className="nsu-act-val">
                    {selectedIns?.subscriber_contact_email}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p className="no-appoinmnts-here">No Insurance found.</p>
      )}

      {insAddEditPopup && (
        <AddEditPatInsPopup
          handleClose={() => setInsAddEditPopup(false)}
          patientId={patientId}
          insId={changeInsId}
        />
      )}
      {checkInsStatus && (
        <ConfirmDialog
          bodytext={`There already exist a ${selInsTypeText} insurance in the active insurance list, do you want to make this last (${nextInsTypeText}) Insurance?`}
          closeDialog={() => setCheckInsStatus(false)}
          successDialog={handleChangeInsStatusConfirm}
          sucPrams={sucPrams}
        />
      )}
    </div>
  );
}

export default PatientInsurance;
